/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/users.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Users redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Friday, August 18, 2023 - 6:07 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/08/18  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyid: 0,
  locationid: 0,
  roleid: 0,
  userstatusid: 0,
  error: null,
};

const updateFieldReducer = (state, action, field) => {
  if (action.payload !== null) {
    state[field] = action.payload[field];
    state.error = null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    updateCompany: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateLocation: (state, action) => updateFieldReducer(state, action, "locationid"),
    updateRole: (state, action) => updateFieldReducer(state, action, "roleid"),
    updateUserStatus: (state, action) => updateFieldReducer(state, action, "userstatusid"),
  },
});

export const { updateCompany, updateLocation, updateRole, updateUserStatus } = usersSlice.actions;

export default usersSlice.reducer;
